module.exports = __webpack_public_path__ + "img/1326.d3e88127.gif";